export  function jsonParser(res) {
  return JSON.parse(res.replace(/"([^"]+)":/g,function($0,$1){return ('"'+$1.toLowerCase()+'":');}))
}